module.exports = __webpack_public_path__ + "static/media/abc.96bcf62b.jpg";